import {getTestProps} from '@benchling/js-test-utils';
import {css, StyleSheet} from 'aphrodite';
import 'brace';
import 'brace/mode/json';
import 'brace/theme/github';
import React from 'react';
import AceEditor from 'react-ace';
interface ConfigureSchemaSpecProps {
  link: {
    value: string;
    onChange: (e: {target: {value: string}}) => void;
  };
  readOnly?: boolean;
}

export function ConfigureSchemaSpec({link, readOnly = false}: ConfigureSchemaSpecProps): JSX.Element {
  return (
    <div className={css(styles.section)} {...rootTestProps}>
      <div className="settingsPageContainer-label">JSON Spec</div>
      <AceEditor
        mode="json"
        theme="github"
        enableBasicAutocompletion={true}
        value={link.value}
        onChange={(newValue) => {
          link.onChange({target: {value: newValue}});
        }}
        readOnly={readOnly}
        width="100%"
      />
    </div>
  );
}

const styles = StyleSheet.create({
  section: {
    marginBottom: 30,
  },
});

const rootTestProps = getTestProps({component: 'ConfigureSchemaSpec', element: 'root'});
